var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "Clip-2",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.43857 16.5181C8.43857 17.5358 8.42206 18.5538 8.44683 19.5709C8.45612 19.9519 8.37288 20.041 7.98523 19.9661C4.15209 19.2248 0.918134 15.9668 0.188242 12.086C-0.872201 6.44715 2.6469 1.2442 8.24699 0.170325C13.7907 -0.892457 19.2573 3.14334 19.9249 8.79082C20.5451 14.0388 17.2668 18.7501 12.1782 19.9232C11.5659 20.0646 11.5656 20.0646 11.5656 19.4495C11.5656 17.446 11.5745 15.4421 11.5573 13.439C11.5545 13.0863 11.6371 12.9653 12 12.9882C12.519 13.0211 13.0425 12.9854 13.5636 13.0014C13.8168 13.0093 13.9196 12.9362 13.9537 12.6671C14.0469 11.9268 14.169 11.1896 14.2973 10.4545C14.3441 10.1844 14.2825 10.0825 13.995 10.089C13.3002 10.105 12.6043 10.0845 11.9092 10.0994C11.6436 10.1053 11.5487 10.0245 11.5601 9.74923C11.581 9.22529 11.5576 8.69962 11.5724 8.17499C11.5989 7.22595 12.0856 6.70756 13.0281 6.63301C13.3896 6.60457 13.7549 6.60978 14.1178 6.62157C14.3537 6.62919 14.46 6.56609 14.4535 6.30429C14.4383 5.68465 14.4469 5.06432 14.45 4.44399C14.4507 4.26958 14.4304 4.14232 14.211 4.11354C13.207 3.98282 12.2029 3.83822 11.1941 4.04835C9.54889 4.39128 8.50771 5.70268 8.4458 7.52311C8.42138 8.23776 8.42378 8.95448 8.4458 9.66913C8.45543 9.99369 8.37494 10.1182 8.03166 10.1019C7.4483 10.0741 6.86218 10.1046 6.27813 10.0897C6.0095 10.0828 5.87466 10.1327 5.88464 10.4514C5.90699 11.182 5.90768 11.9147 5.88395 12.6453C5.87363 12.9664 6.01087 13.008 6.27676 13.0014C6.87697 12.9861 7.47822 13.0135 8.0781 12.9896C8.3801 12.9778 8.44889 13.0842 8.44477 13.3696C8.42929 14.4189 8.43857 15.4685 8.43857 16.5181",
    id: "Fill-1",
    fill: "#1977F1",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbicon);
export default __webpack_public_path__ + "static/media/fbicon.af42f953b8904a37d5c592984ef1d00c.svg";
export { ForwardRef as ReactComponent };